import { useEffect, useState } from 'react';
// import { Table } from 'react-bootstrap';
import { Button, Table } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import PdfFile from './icons/PdfFile';
import EditIcon from './icons/EditIcon';
import StandardModal from './StandardModal';

const StandardsList = () => {
  const { token } = useAuth();
  const [standards, setStandards] = useState<any[]>([]);
  const [activeStandard, setActiveStandard] = useState<any | null>(null);
  
  // const bullet = '🟢'; // using an emoji here

  // const pdfs = {
  //   'josef': 'Medizinprodukteregister_Josefstadt.pdf',
  //   'wilhelm': 'Medizinprodukteregister_Wilhelmshöhe.pdf'
  // };

  useEffect(() => {
    fetch('/api/standards/list' , {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(setStandards);
  }, [token]);

  const pdf_path = (std_filename: string): string => {
    return `/api/standards/pdfs/${std_filename}`;
  }

  const mailto_link = (std: any): string => {
    const recepient = 'office@ritoc.at';
    const subject = encodeURIComponent(`Änderung des Standards: ${std.nr} - ${std.name}`);
    const body_string = 
`Sehr geehrte Damen und Herren, 

ich möchte eine Änderung des Standards "${std.nr} - ${std.name}" veranlassen. 
Bitte leiten Sie die notwendigen Schritte ein.

Mit freundlichen Grüßen,
[Ihr Name]

Ziel:

Vorbereitung:

Wichtige Informationen

Durchführung:

Nachbereitung und Versorgung:

Sonstiges:

Quellenverzeichnis:

Verantwortlich:

Gesehen:

`
    const body = encodeURIComponent(body_string);
    return `mailto:${recepient}?subject=${subject}&body=${body}`;
  }

  return (
    <>
      {/* <Table striped bordered className='standards-table'> */}
      <Table className='standards-table'>

{/* 
standard = {
  "name": parts[0],
  "institution": parts[1],
  "profession": parts[2],
  "abbr": parts[3],
  "category": parts[4],
  "nr": parts[5],
  "filename": parts[6],
  "short_name": parts[7],
  "version": parts[8],
  "revision": parts[9],
  "cre_date": parts[10],
  "created_by": parts[11],
  "examined_by": parts[12],
  "release": parts[13],
  "status": parts[14],
  "id": len(standards) + 1,
} */}

        <thead>
          <tr className='std_head'>
            <th className='std_number'>Nr</th>
            <th className='std_name'>Bezeichnung</th>
            <th className='std_institution'>Anstalt</th>
            <th className='std_version'>Version</th>
            <th className='std_link'>Link</th>
            <th className='std_action'>Änderung</th>
          </tr>
        </thead>
        <tbody>
          {standards.map(std => (
            <tr key={std.id} className='std_row'>
              <td className='std_number' onClick={() => setActiveStandard(std)}>{std.nr}</td>
              <td className='std_name' onClick={() => setActiveStandard(std)}>{std.name}</td>
              <td className='std_institution' onClick={() => setActiveStandard(std)}>{std.institution}</td>
              <td className='std_version' onClick={() => setActiveStandard(std)}>{std.version}</td>
              <td className='std_link'>
                <a href={pdf_path(std.filename)} target="_blank">
                <Button variant="secondary" size="sm" className="mb-2">
                  <PdfFile />
                  <span style={{ marginRight: '8px', marginLeft: '8px' }}>PDF Download</span>
                </Button>
                </a>
              </td>
              <td className='std_action'>
                {/* <a href={mailto_link(std.filename)} target="_blank"> */}
                <a href={mailto_link(std)} target="_blank">
                <Button variant="secondary" size="sm" className="mb-2">
                  <EditIcon />
                  <span style={{ marginRight: '8px', marginLeft: '8px' }}>Änderung veranlassen</span>
                </Button>
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {activeStandard && (
        <StandardModal
          show={true}
          std={activeStandard}
          onClose={() => setActiveStandard(null)}
        />
      )}
    </>
  );
};

export default StandardsList;
